module.exports = __webpack_public_path__ + "img/2_124.e4ed4d07.png";